import type React from 'react'
import { createContext, useContext } from 'react'
import type { UseSliderReturn } from './useSlider'

interface SliderContextValues
  extends Omit<UseSliderReturn, 'getInputProps' | 'getRootProps'> {}

export const SliderContext = createContext<SliderContextValues | null>(null)

export const SliderContextProvider =
  SliderContext.Provider as React.Provider<SliderContextValues>

export const useSliderContext = () => {
  const context = useContext(SliderContext)

  if (context === null) {
    throw new Error(
      'Attempted to call useSliderContext outside the Slider component.'
    )
  }

  return context
}
